const OkSvg = () => {
  return ( 
    <svg width="15" height="11" viewBox="0 0 46 36" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M0 20.0699L5.98149 15.2542L16.2277 25.4875L40.8769 0L46 4.7787L15.9067 36L0 20.0699Z" fill="#009c30"/>
    </svg>
  )}
  
  export default OkSvg;